export default class class_check_language {

    is_italian(){
        let lang = document.getElementsByTagName('html')[0].getAttribute('lang');
        if (lang == 'it-IT'){
            return true;
        }
        return false;
    }

}